export enum AvartarType {
  MEMBER = 1,
  CUSTOMER,
  TEXT,
}
